const cutTypeIdMap = new Map()
cutTypeIdMap.set("Láser Metal", "metal", );
cutTypeIdMap.set("Láser Plásticos", "plastic");
cutTypeIdMap.set("Láser Tubo", "tube");
cutTypeIdMap.set("Router CNC", "cnc");

export { cutTypeIdMap };